import type { ReactElement } from 'react';
import { Icon, type IconProp } from 'components/Icon';
import type { ProductKind } from 'types';
import { PlanRow } from 'modules/campaign/row';
import { rowIconLock, rowIcons } from './PlanRowIcons.css';

const kindIconMap: Record<ProductKind, IconProp> = {
  MEDIA: 'rectangle-ad',
  SERVICE: 'screwdriver-wrench',
  SMART: 'wand-magic-sparkles',
};

export function PlanRowKindIcon({ kind }: { kind: ProductKind }): ReactElement {
  return <Icon icon={kindIconMap[kind]} />;
}

export function PlanRowIcons({ row }: { row: PlanRow }): ReactElement {
  return (
    <div className={rowIcons}>
      <PlanRowKindIcon kind={row.kind} />
      {row.state.is_locked && <Icon icon="lock" className={rowIconLock} />}
    </div>
  );
}
